import { InfoField, Link } from '@occc/ui-design-system';

import {
  arrangeNodeGroups,
  renderNodeGroups,
} from '@occc-app/routes/CampaignComponents/component-details/sections/utils';
import { OfferLink } from './links-section.utils';
import { SectionCard } from '../../components';
import { BREAK_URLS_STYLE } from '../constants';

type LinksSectionProps = {
  links: OfferLink[];
};

export const LinksSection = ({ links }: LinksSectionProps) => {
  if (!links.length) {
    return null;
  }

  const blockGroups = arrangeNodeGroups(
    links.map(({ label, href }) => (
      <InfoField
        key={label}
        label={label}
        value={
          <Link href={href} target='_blank' rel='noopener noreferrer' sx={BREAK_URLS_STYLE}>
            {href}
          </Link>
        }
        disableTypography
      />
    )),
    2,
  );

  return <SectionCard title='Links'>{renderNodeGroups(blockGroups, 2)}</SectionCard>;
};
